import { render } from "./ProductTile.vue?vue&type=template&id=b6c7a062"
import script from "./ProductTile.vue?vue&type=script&lang=js"
export * from "./ProductTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__